<span class="error-snackbar-text"
    [attr.data-cy]="errorSnackbarDataCy.SNACK_BAR">
    <mat-icon fontSet="material-symbols-sharp"
        class="material-symbols-sharp_bold error-snackbar-text__icon">
        cancel
    </mat-icon>
    {{message}}
</span>
<button [buttonType]="'primary'"
    *ngIf="hasAction"
    (click)="dismiss()">{{action}}</button>
